var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAudioBackward(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#004378",
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.37462069 24.6441481c2.16403448 1.7795556 4.89020691 2.8373334 7.85813791 2.8373334 7.0758621 0 12.7758621-6.0148148 12.7758621-13.4814815 0-7.46666667-5.7-13.48148148-12.7758621-13.48148148-5.1103448 0-9.72931032 3.31851852-11.69482757 7.98518518"
  }), /*#__PURE__*/React.createElement("ellipse", {
    strokeLinecap: "square",
    cx: 4.42241379,
    cy: 21.2592593,
    rx: 3.93103448,
    ry: 4.14814815
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M2.55517241.51851852l.98275862 7.98518518 7.56724137-1.03703703"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.62015 17.5h-.98496v-4.7985h-1.61082v-.7245c.9234-.021 1.55952-.546 1.71342-1.281h.88236V17.5zm1.1286-1.848l.96444-.294c.06156.84.6669 1.407 1.49796 1.407.79002 0 1.42614-.5355 1.42614-1.3755 0-.9345-.6669-1.407-1.4364-1.407-.47196 0-.9234.189-1.21068.4935-.34884-.1365-.64638-.273-.98496-.399l.86184-3.381h3.50892v.945h-2.84202l-.49248 1.953c.29754-.336.83106-.504 1.35432-.504 1.30302 0 2.2572.8505 2.2572 2.2575 0 1.281-.96444 2.3205-2.44188 2.3205-1.41588 0-2.37006-.945-2.4624-2.016z",
    fill: "#004378",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioBackward);
export default __webpack_public_path__ + "static/media/audio-backward.a5b10f7858d44dbe03b698f054923496.svg";
export { ForwardRef as ReactComponent };